export default __webpack_public_path__ + "static/media/slide3.2161c344.jpeg";